import { __ } from "@wordpress/i18n";
import {
	PanelBody,
	ButtonGroup,
	Button,
	__experimentalUnitControl as UnitControl,
} from "@wordpress/components";
import { useState } from "@wordpress/element";

const DEVICES = [
	{ label: __("Desktop", "sfb"), value: "Desktop" },
	{ label: __("Tablet", "sfb"), value: "Tablet" },
	{ label: __("Mobile", "sfb"), value: "Mobile" },
];

const UNITS = [
	{ value: "px", label: "px" },
	{ value: "rem", label: "rem" },
];

export default function ResponsiveGapControl({ attributes, setAttributes }) {
	const [activeDevice, setActiveDevice] = useState("Desktop");

	const getAttributeName = (property) => {
		return `${property}${activeDevice}`;
	};

	const getValue = (property) => {
		const value = attributes[getAttributeName(property)];
		if (!value || typeof value !== "object") return "";
		return `${value.value || ""}${value.unit || "px"}`;
	};

	const setValue = (property, newValue) => {
		// Parse value and unit from string like "16px" or "1rem"
		const match = newValue?.match(/^(\d*\.?\d+)(\w+)?$/);
		if (!match) {
			setAttributes({
				[getAttributeName(property)]: { value: "", unit: "px" },
			});
			return;
		}

		const [, value, unit = "px"] = match;
		setAttributes({
			[getAttributeName(property)]: {
				value: value,
				unit: unit,
			},
		});
	};

	return (
		<PanelBody title={__("Gap", "sfb")} initialOpen={false}>
			{/* Device Tabs */}
			<div style={{ marginBottom: "16px" }}>
				<ButtonGroup>
					{DEVICES.map((device) => (
						<Button
							key={device.value}
							variant={activeDevice === device.value ? "primary" : "secondary"}
							onClick={() => setActiveDevice(device.value)}
						>
							{device.label}
						</Button>
					))}
				</ButtonGroup>
			</div>

			{/* Row Gap */}
			<UnitControl
				label={__("Row Gap", "sfb")}
				value={getValue("rowGap")}
				onChange={(value) => setValue("rowGap", value)}
				units={UNITS}
			/>

			{/* Column Gap */}
			<UnitControl
				label={__("Column Gap", "sfb")}
				value={getValue("columnGap")}
				onChange={(value) => setValue("columnGap", value)}
				units={UNITS}
			/>
		</PanelBody>
	);
}
